import bootstrapper from '../bootstrapper';

/* eslint-disable camelcase */
const userBucketedInExperiment = (experimentName) => {
  const experiments = bootstrapper.activeExperiments?.active_experiment;

  return experiments?.some(e => e.includes(experimentName)) || false;
};
/* eslint-enable camelcase */

export default userBucketedInExperiment;
